import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("oms_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const STATUS_ORDER = [
  "Draft", "Submitted", "Accounts Hold", "Approved", "Rejected",
  "Production Planned", "In Production", "Production Completed",
  "Dispatch Planned", "Dispatched", "Closed",
];

export const STATUS_COLORS = {
  "Draft":                { bg: "#F1F5F9", text: "#475569", border: "#CBD5E1" },
  "Submitted":            { bg: "#EFF6FF", text: "#1D4ED8", border: "#BFDBFE" },
  "Accounts Hold":        { bg: "#FFFBEB", text: "#B45309", border: "#FDE68A" },
  "Approved":             { bg: "#ECFDF5", text: "#047857", border: "#A7F3D0" },
  "Rejected":             { bg: "#FEF2F2", text: "#B91C1C", border: "#FECACA" },
  "Production Planned":   { bg: "#F5F3FF", text: "#6D28D9", border: "#DDD6FE" },
  "In Production":        { bg: "#EEF2FF", text: "#4338CA", border: "#C7D2FE" },
  "Production Completed": { bg: "#ECFEFF", text: "#0E7490", border: "#A5F3FC" },
  "Dispatch Planned":     { bg: "#FEFCE8", text: "#A16207", border: "#FEF08A" },
  "Dispatched":           { bg: "#F7FEE7", text: "#4D7C0F", border: "#D9F99D" },
  "Closed":               { bg: "#F3F4F6", text: "#374151", border: "#D1D5DB" },
};

export function formatINR(n) {
  if (n == null || isNaN(n)) return "₹0";
  return "₹" + Number(n).toLocaleString("en-IN", { maximumFractionDigits: 2 });
}

export function fmtDate(s) {
  if (!s) return "-";
  try { return new Date(s).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }); }
  catch { return s; }
}

export function fmtDateTime(s) {
  if (!s) return "-";
  try { return new Date(s).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }); }
  catch { return s; }
}
